import { Injectable } from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  private readonly inIframe = self !== top;
  private embeddedClassApplied = false;

  private _loaderTimer: Subscription | null = null;
  private _loader: HTMLElement | null = null;

  private get loader(): HTMLElement | null {
    if (!this._loader) {
      this._loader = document.getElementById('preloader');
      if (!this._loader) console.warn('Preloader element not found');
    }
    return this._loader;
  }

  hidden: Subject<void>;

  constructor() {
    if (self === top) document.body.classList.add('body-loading');
    this.hidden = new Subject<void>();
    this.applyEmbeddedClass();
  }

  enable(): void {
    if (!this.loader) return;
    this.applyEmbeddedClass();
    this.loader.style.visibility = 'visible';
    this.loader.classList.remove('loaderDelayed');
    this.changeAnimationDuration('2.5s');
    this.cancelLoaderDelayedTimer();
    this.setLoaderDelayedTimer();
  }

  disable(): void {
    if (!this.loader) return;
    this.loader.style.visibility = 'hidden';
    document.body.classList.remove('body-loading');
    this.loader.classList.remove('loaderDelayed');
    this.cancelLoaderDelayedTimer();
    this.hidden.next();
  }

  setLoaderDelayedTimer(): void {
    if (this._loaderTimer)
      throw new Error(
        'A loader delayed timer already exists. First cancel it before setting a new one'
      );

    this._loaderTimer = timer(30_000).subscribe(() => {
      this.loader?.classList.add('loaderDelayed');
      if (this.loader?.classList.contains('loaderDelayed')) {
        this.changeAnimationDuration('15s');
      }
    });
  }

  cancelLoaderDelayedTimer(): void {
    this._loaderTimer?.unsubscribe();
    this._loaderTimer = null;
  }

  changeAnimationDuration(duration: string): void {
    const animateTransform = document.querySelector(
      '.loader__wrapper svg animateTransform'
    );
    if (animateTransform) {
      animateTransform.setAttribute('dur', duration);
    } else {
      console.warn('animateTransform element not found');
    }
  }

  private applyEmbeddedClass(): void {
    if (this.inIframe && !this.embeddedClassApplied) {
      document.documentElement.classList.add('embed');
      this.embeddedClassApplied = true;
    }
  }
}
